/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/author/:name'>.
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import CookPage from '@routes/CookPage';
import { getQueryClient } from '../../providers/query';
import { authorQueryOptions } from '@queries/index';
import { isContentNotFoundError } from '../../api/contentNotFound';

export const Route = createFileRoute('/author/$name')({
  /**
   * ЭТАП 2 — честный 404 несуществующего автора: бэк (recipesResolver
   * .getAuthor) кидает CONTENT_NOT_FOUND -> notFound() -> HTTP 404 + контент
   * /404 без редиректа. Лоадеры TanStack параллельны root-префетчу, поэтому
   * await ensureQueryData: дедуп по ключу с зависимым префетчем автора
   * (ssrPrefetch), лишнего запроса нет; серверный клиент ретраит всё, кроме
   * CONTENT_NOT_FOUND, — 404 остаётся быстрым.
   *
   * На КЛИЕНТСКОЙ навигации не блокируем: там остаётся прежнее поведение
   * CookPage — редирект на /cook по ошибке запроса (эффект в компоненте).
   */
  loader: async ({ params }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    const queryClient = getQueryClient();
    const options = authorQueryOptions({
      identify: decodeURIComponent(params.name)
    });
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={CookPage} path='/author/:name' />
});
